<section class="content profile-page"  >
  <div class="block-header">
      <div class="">
           <div class="row ">
             <div class="col-md-12 p-0">
              <h2 class="poppins font-weight-bold pl-2">Bulk Upload</h2>
             </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">
                 
                  <div class="breadcrumb flat">
                      <a [routerLink]="['/home']"> 
                          Home</a>
                          <a href="#" class="active">Bulk Upload</a>
                  </div>
                 </div>
                <div class="col-md-7 ">
                  <div class="float-right">  
                  
                  </div>
              </div>
          </div>
      </div>

  </div>
  <div class="  ">
      <div class="row">
          <div class="col-md-12 p-0">
              <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row mx-0">
                      <div class="col-md-12">
                          <h4 class="font-weight-bold"  >Bulk Upload</h4>
                       
                      </div>

                  </div>
                  <div class="row mx-0">
                      <div class="col-md-12">
                        <div class="form-group">

                          <div class="row px-3">
                            <div class="col-md-7">
                            
                              <div class=" m-b-0" fxFlex="100">
                                <form #fnew="ngForm">
                                  <div class="m-b-0">
                                   
                                    <div>
                                    
                                    </div>
                                                                   <label class="h6 pt-2" for="avatar">Insert Bulk Upload File     </label> 
                                                                      <div class="pb-3 col-md-12"  >
                                                                        <input type="file" id="file" multiple (change)="getFileDetails($event)" accept=".csv">
                                                                        <!-- [disabled]="file.invalid"  -->
                                                                        <!-- <span class="text-danger"
                                                                        *ngIf="file.invalid && (file.dirty || file.touched)">{{fileNameerrors()}}</span> -->
                                                                        <span  *ngIf="UploadFilebutton">
                                                                          <button class="btn box-button" color="primary" id="uploadFile" 
                                                                            (click)="uploadFiles()">UploadFile</button>
                                                                        </span>
                                                                      
                                                                      </div>  
                                                                      <span>allowing .csv Files only</span>   
                                                                                                   </div>
                                </form>
                              </div>
                            </div>
                           
                          </div>           
  
                          
                            </div>
                            

                      </div>
                    



                   
              </div>
          </div>
      </div>
  </div>

  </div>
</section>         

